import { getHeight, getWidth } from "./Helper";
//Theme Constants
export const titanStyle = {
    titan_window: {
        height: getHeight(), //get window heigth
        width: getWidth(), // get window width
    },

    titan_fontFamily: 'Roboto', 
    
    titan_textAlign: {
        _left: 'left',
        _center: 'center',
        _right: 'right',
    },
    
    titan_letterSpacing: {
        _normal: 'normal'
    },
    
    titan_lineHeight: {
        lineHeight_1_21: 1.21,
        lineHeight_1_17: 1.17,
    },
    
    titan_fontSize: {
        fontSize_10: '10px',
        fontSize_11: '11px',
        fontSize_12: '12px',
        fontSize_13: '13px',
        fontSize_14: '14px',
        fontSize_15: '15px',
        fontSize_16: '16px',
        fontSize_17: '17px',
        fontSize_18: '18px',
        fontSize_19: '19px',
        fontSize_20: '20px',
        fontSize_21: '21px',
    },
  
    titan_color: {
        color_black: '#212121',
        color_c62828: '#c62828',
        color_light_rose: '#ffcdd2',
        color_warm_grey_two: '#757575',
        color_9e9e9e: '#9e9e9e',
        color_cfd8dc: '#cfd8dc',
        color_ffffff: '#ffffff',
        color_e0e0e0: '#e0e0e0',
        color_01345d: '#01345d',
        color_014e8c: '#014e8c',
        color_679ac3: '#679ac3',
        color_f5f5f5: '#f5f5f5',
        color_darkish_green: '#2e7d32',
        color_e8f5e9: '#e8f5e9',
        color_red: '#d32f2f',
        color_pale_grey: '#eceff1',
        color_pale_blue: '#e1f5fe',
        color_peacock_blue :'#01579b',
        color_3949ab: '#3949ab',
    },
  
    titan_fontWeigth: {
        fontWeigth_normal: 'normal',
        fontWeigth_100: 100,
        fontWeigth_200: 200,
        fontWeigth_300: 300,
        fontWeigth_400: 400,
        fontWeigth_500: 500,
        fontWeigth_600: 600,
        fontWeigth_700: 700,
        fontWeigth_800: 800,
    },
   
    titan_padding: {
        padding_1: '1px',
        padding_2: '2px',
        padding_3: '3px',
        padding_4: '4px',
        padding_5: '5px',
        padding_6: '6px',
        padding_7: '7px',
        padding_8: '8px',
        padding_9: '9px',
        padding_10: '10px',
        padding_11: '11px',
        padding_12: '12px',
        padding_13: '13px',
        padding_14: '14px',
        padding_15: '15px',
        padding_16: '16px',
        padding_17: '17px',
        padding_18: '18px',
        padding_19: '19px',
        padding_20: '20px',
    },
   
    titan_margin: {
        margin_1: '1px',
        margin_2: '2px',
        margin_3: '3px',
        margin_4: '4px',
        margin_5: '5px',
        margin_6: '6px',
        margin_7: '7px',
        margin_8: '8px',
        margin_9: '9px',
        margin_10: '10px',
        margin_11: '11px',
        margin_12: '12px',
        margin_13: '13px',
        margin_14: '14px',
        margin_15: '15px',
        margin_16: '16px',
        margin_17: '17px',
        margin_18: '18px',
        margin_19: '19px',
        margin_20: '20px',
    },
    
    titan_fontStretch: {
        _normal: 'normal',
    },
   
    titan_borderRadius: {
        borderRadius_1: '1px',
        borderRadius_2: '2px',
        borderRadius_3: '3px',
        borderRadius_4: '4px',
        borderRadius_5: '5px',
        borderRadius_6: '6px',
        borderRadius_7: '7px',
        borderRadius_8: '8px',
        borderRadius_9: '9px',
        borderRadius_10: '10px',
        borderRadius_11: '11px',
        borderRadius_12: '12px',
        borderRadius_13: '13px',
        borderRadius_14: '14px',
    },
    titan_cursorActions:{
        pointer:'pointer'
    }
}